import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CurrencyModule } from '@fantaz/shared/ui/currency';
import { PlayControlsComponent } from './play-controls/play-controls.component';
import { SubscriptionModule } from '@fantaz/shared/ui/subscribe';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    CurrencyModule,
    MatButtonModule,
    SubscriptionModule,
  ],
  declarations: [PlayControlsComponent],
  exports: [PlayControlsComponent],
})
export class TournamentsUiPlayControlsModule {}
